import React, { useState } from 'react';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:3050';

function AuthModal({ onLoginSuccess, showNotification, setAuthView }) {
    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');

    const handleLogin = async (e) => {
        e.preventDefault();
        try {
            const res = await fetch(`${API_URL}/api/auth/login`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ username, password }),
            });
            const data = await res.json();
            if (!res.ok) throw new Error(data.message || 'Login failed');
            onLoginSuccess(data);
        } catch (err) { showNotification(err.message, 'error'); }
    };

    return (
        <div className="login-box">
            <div className="login-header">
                <svg className="logo" viewBox="0 0 100 100"><path d="M 10,90 L 50,10 L 90,90 Z" fill="#fff" /><path d="M 30,90 L 50,50 L 70,90 Z" fill="#a78bfa" /></svg>
                <h2>Stockify</h2>
                <p>Sign in to continue</p>
            </div>
            <form onSubmit={handleLogin}>
                <div className="input-group">
                    <label>Username</label>
                    <input type="text" value={username} onChange={e => setUsername(e.target.value)} required />
                </div>
                <div className="input-group">
                    <label>Password</label>
                    <input type="password" value={password} onChange={e => setPassword(e.target.value)} required />
                </div>
                <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '1rem', fontSize: '0.85rem' }}>
                    <button type="button" onClick={() => setAuthView('forgot-username')} style={{ background: 'none', border: 'none', color: 'var(--color-primary)', cursor: 'pointer', padding: 0 }}>Forgot Username?</button>
                    <button type="button" onClick={() => setAuthView('forgot-password')} style={{ background: 'none', border: 'none', color: 'var(--color-primary)', cursor: 'pointer', padding: 0 }}>Forgot Password?</button>
                </div>
                <button type="submit" className="login-button">Sign In</button>
            </form>
            <div className="auth-switch">
                <p>Don't have an account? <button onClick={() => setAuthView('register')}>Register Company</button></p>
            </div>
        </div>
    );
}

export default AuthModal;
